import { render } from "./DemoDashboardView.vue?vue&type=template&id=5c4f5bb6"
import script from "./DemoDashboardView.vue?vue&type=script&lang=js"
export * from "./DemoDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__